<template>
  <div class="login-callback-page">Redirecting...</div>
</template>

<script>
import jwt_decode from 'jwt-decode';

export default {
  name: 'login-callback-page',
  components: {},
  beforeMount() {
    const hash = this.$route.hash;
    const token = hash.split('&')[0].replace('#id_token=', '');
    localStorage.setItem('token', token);
  }
};
</script>
